import React from 'react';
import { Icon } from 'antd';
import { FormField, isStepValid } from 'utils/registration/formUtils';
import formConfig from 'utils/registration/dod/fields/personalInformationFields';
import PIA from 'actions/dod/dodPersonalInformationActions';
const { firstGivenName, middleName, lastFamilySurname } = formConfig;

const init = {
    status: 'invalid',
    description: 'Personal Information',
    title: (
        <div>
            <Icon type='user' />
            {' Step 2'}
        </div>
    ),
    forms: {
        firstGivenName: new FormField(firstGivenName),
        middleName: new FormField(middleName),
        lastFamilySurname: new FormField(lastFamilySurname)
    }
};

export default (state=init, action) => {
    switch(action.type) {
        case PIA.UPDATE_DOD_PERSONAL_INFORMATION_FIELD:
            // Narrowing scope deliberately.
            return ((s, a) => ({...s,
                status: isStepValid(s, a.payload) ? 'valid' : 'invalid',
                forms: {...s.forms, [a.payload.formProp]: a.payload }
            }))(state, action)

        case PIA.UPDATE_DOD_PERSONAL_INFORMATION_TITLE:
            return {...state, title: action.payload };

        default: return {...state};
    }
}
